import React from 'react'
import './footer.css'

function Footer() {
  const currentYear = new Date().getFullYear();
  
  return (
    <footer className="modern-footer no-print"> 
      <div className="container"> 
        <div className="footer-content">
         
          <div className="footer-copyright">
            Copyright © <span>{currentYear}</span> <a href="#">ENTREPRENEURSHIP DEVELOPMENT CENTER, NSUK</a>
            <br />
            Developed by <a href="#">Deep Socket</a>. All rights reserved.
          </div>
        </div>
      </div>
    </footer>
  )
}
export default Footer